import { render } from "./CommonAuthorFive.vue?vue&type=template&id=19a4362a"
import script from "./CommonAuthorFive.vue?vue&type=script&lang=js"
export * from "./CommonAuthorFive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__